import { CircularProgress } from '@material-ui/core'
import Typography from '@material-ui/core/Typography'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'
import WarningOutlinedIcon from '@material-ui/icons/WarningOutlined'

import useStyles from './index.styles'

type Props = {
  status: boolean
  inprogress?: boolean
}

export default function StateBox({ status, inprogress }: Props) {
  const classes = useStyles()

  // Determine which state to show
  if (inprogress) {
    return (
      <div className={classes.inProgressBadge}>
        <CircularProgress size={16} className={classes.inProgressIcon} />
        <Typography className={classes.inProgressText}>In Progress</Typography>
      </div>
    )
  }

  return (
    <div
      className={[
        classes.okBadge,
        status === false ? classes.warningBadge : ''
      ].join(' ')}>
      {status ? (
        <>
          <CheckCircleOutlineIcon className={classes.okIcon} fontSize="small" />
          <Typography className={classes.trueText}>OK</Typography>
        </>
      ) : (
        <>
          <WarningOutlinedIcon
            className={classes.warningIcon}
            fontSize="small"
          />
          <Typography className={classes.warningText}>Warning</Typography>
        </>
      )}
    </div>
  )
}
